document.addEventListener('crPickupActivated', function (e) {
	//$('#store-search').prepend('<input type="text" name="pickup-store-search" id="pickup-store-search" onkeyup="storePickup.storeFilter()" placeholder="Chercher..." class="valid" aria-invalid="false">')            

	jqCR('#storeUL li a').each(function(){
        var storeId = jQuery(this).data('store-id');
      	var zipCode = jQuery(this).data('zip-code');
        var city = jQuery(this).data('city');
      	var storeName = jQuery(this).data('name');
        var address = jQuery(this).data('address');
      	var country = jQuery(this).data('country'); 
      
        var zipSection = jQuery(this).find('br').remove()
        var zipSection = jQuery(this).find('span').remove()
        //var nameSection = jQuery(this).find('strong').eq(0).html(storeName + ' - ' + zipCode);
        jQuery(this).find('.cr-store-address').html(address + '<br> ' + city + ', ' + zipCode + '<br>' + country)
   
    })
})

